<template>
  <div class="">

    <h2>Доступ ограничен</h2>
    <back></back>

    <div class="wh-block">
      <!-- Если закончилось обучение препода на курсах -->
      <template v-if="user && user.property && (user.property.is_course_student && user.property.is_course_student == 1)">
        <p><strong>Ваше обучение закончено.</strong></p>
        <p><strong>Обновите страницу и ваш статус изменится с ученика на преподавателя.</strong></p>
      </template>

      <!-- Если препод просрочил абонемент -->
      <template v-else-if="user && user.has_teachers">
        <p><strong>Обратитесь к своему преподавателю за подробностями.</strong></p>
      </template>

      <!-- Если кончился абонемент ученика -->
      <template v-else-if="user && !user.has_teachers">
        <p><strong>Абонемент закончился. Необходимо продлить абонемент</strong></p>
        <ul class="uk-grid-match" uk-grid>
          <li class="uk-width-1-2@s">
            <div>
              <div class="podpiska__finish">
                <p><strong>ПОДПИСКА ЗАКОНЧИЛАСЬ!</strong></p>
                <p v-if="user.balance >= subscribe_price">
                  <a class="podpiska__button" href="#" @click="onExtendSubscribe">Продлить подписку</a>
                </p>
                <p v-else>
                  На вашем счету недостаточно средств. Пополните баланс чтобы продлить подписку. Необходимая сумма для продления: {{ subscribe_price }} руб.
                </p>
              </div>
            </div>
          </li>
          <li class="uk-width-1-2@s">
            <div>
              <label>
                <span>Ваш баланс</span>
                <strong>{{ user.balance }} руб</strong>
                <div class="podpiska__fwrap">
                  <input type="text" v-model="sum" placeholder="Введите сумму" class="uk-input">
                  <button class="podpiska__button" href="#" @click="addMoney">+ Пополнить баланс</button>
                </div>
              </label>
            </div>
          </li>
        </ul>
      </template>


    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import swal from "sweetalert";

export default {
  name: "Info",
  data() {
    return {
      sum: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    prices() {
      return this.$store.state.prices;
    },
    subscribe_price() {
      let price = this.prices.solo_student;
      return price;
    }
  },
  inject: ['http'],
  methods: {
    async onExtendSubscribe() {
      let data = {
        'user_id': this.user.id,
        'subscribe_price': this.subscribe_price
      }
      let result = await this.http.post('onExtendSubscribe', data).then((res) => {
        console.log(res);
        if (res.data.message) swal(res.data.message, "", "success");
        if (res.data.user) {
          this.$store.commit('setUser', res.data.user);
        }
      });
    },
    async addMoney() {
      if (!this.sum) {
        swal('Укажите сумму', "", "warning");
      } else {
        let data = {
          'user_id': this.user.id,
          'sum': this.sum,
          'name': this.user.name
        }
        let result = await this.http.post('onAddMoney', data).then(function (res) {
          console.log(res);
          if (res.data.formUrl) {
            window.location.href = res.data.formUrl;
          }
        });
      }
    },
  }
}
</script>